<template>
  <div id="CardHoddy">
    <shop-header :path='path'></shop-header>
    <div @mouseenter='hideMenu()'>
      <router-view></router-view>
    </div>
    <shop-footer :isPath="isPath"></shop-footer>
    <!-- <div class="qr_customer">
      <div class="qr_box">
        <img src="../../static/images/dakaqr.png" />
        联系客服
      </div>
      <span class="icon_customer"></span>
    </div> -->
    <div id="ScrollAll" v-if="istop">
      <div class="scrollUp" @click="scrollBox(0)"></div>
    </div>
  </div>
</template>
<script>
import ShopHeader from './header'
import ShopFooter from './footer'
import bus from '@/api/bus';
export default {
  name: 'layout',
  components: {
    ShopHeader,
    ShopFooter
  },
  data() {
    return {
      path: [],
      isPath: false,
      istop: false,
      dislogType: this.$enumInfo.dislogType,
    }
  },
  watch: {
    '$route': 'getPath'
  },
  mounted() {
    var that = this
    window.addEventListener('scroll', function() {
      if (document.documentElement.scrollTop > 1500) {
        that.istop = true
      } else {
        that.istop = false
      }
    })
  },
  created() {
    this.getPath()
  },
  methods: {
    hideMenu() {
      this.dislogType['market'] = false;
      this.dislogType['userinfo'] = false;
    },
    getPath() {
      this.path = this.$route.path.slice(1).split("/");
      if (this.path[0] == "home" || this.path[0] == "") {
        this.isPath = true
      } else {
        this.isPath = false
      }
    },
    // 滚动 0：滚到顶部，1：滚到底部
    scrollBox(val) {
      if (val != 1) {
        let top = document.documentElement.scrollTop;
        // 实现滚动效果 
        const timeTop = setInterval(() => {
          document.documentElement.scrollTop = (top -= 50);
          if (top <= 0) {
            clearInterval(timeTop); //清除定时器
          }
        }, 0);
      } else {
        let hi = document.documentElement.scrollHeight
        let top = document.documentElement.scrollTop;
        //实现滚动效果 
        const timeDown = setInterval(() => {
          document.documentElement.scrollTop = (top += 50);
          if (top >= hi) {
            clearInterval(timeDown); //清除定时器
          }
        }, 0);
      }
    }
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout.vue